import Image from "next/image";
import { cn } from "@/lib/utils";

export function WiestLogo({
  className,
  width = 110,
  height = 30,
}: {
  className?: string;
  width?: number;
  height?: number;
}) {
  return (
    <Image
      src="/wiest-logo.png"
      alt="Wiest Group Logo"
      width={width}
      height={height}
      priority
      quality={100}
      sizes="(max-width: 768px) 104px, 120px"
      aria-hidden="false"
      role="img"
      className={cn("block h-auto", className)}
      style={{ height: "auto" }}
    />
  );
}

export function WiestLogoWhite({ className }: { className?: string }) {
  return (
    <Image
      src="/wiest-logo-weiss.png"
      alt="Wiest Group Logo"
      width={112}
      height={30}
      quality={100}
      sizes="(max-width: 768px) 104px, 120px"
      aria-hidden="false"
      role="img"
      className={cn("block h-auto", className)}
      style={{ height: "auto" }}
    />
  );
}
